import _ from 'underscore';
import $ from 'jquery';

export default class OrderAttachments {
  constructor($scope, $rootScope, OrderService, FileUploader) {
    function set_uploaders() {
      var uploaders = [{
        name: 'attachment_uploader',
        url: '/admin/marketplace/orders/upload_order_attachment/' + window.order.id,
        element: 'attachment_file'
      }];
      _.each(uploaders, function(uploader) {
        var f = new FileUploader({
          url: uploader.url,
          formData: [{
            authenticity_token: window.token,
            doc_type: $scope.doc_type
          }],
          removeAfterUpload: true
        });
        f.file_element = uploader.element;
        f.onBeforeUploadItem = function(/*item*/) {
          f.processing = true;
        };
        f.onCompleteItem = function(fileItem, response/*, status, headers*/) {
          if (response.success) {
            f.processing = false;
            f.clearQueue();
            $('input.' + f.file_element).val(null);
            load_data();
          }
        };
        $scope[uploader.name] = f;
      });
    }

    function load_data() {
      OrderService.get_attachments(window.order.id, _.pluck($scope.doc_types, 'id')).success(function(data) {
        if (data.success) {
          $scope.attachments = data.attachments;
          _.each($scope.attachments, function(attachment) {
            attachment.doc_type_str = _.findWhere($scope.doc_types, {
              id: attachment.doc_type
            }).title;
          });
          $rootScope.$broadcast('publish_attachments', {
            attachments: $scope.attachments
          });
        }
      });
    }

    $scope.$watch('doc_type', function() {
      if ($scope.attachment_uploader)
        $scope.attachment_uploader.formData[0].doc_type = $scope.doc_type;
    });

    $scope.check_attachments = function() {
      _.each($scope.attachments, function(attachment) {
        attachment.checked = $scope.checked_all_attachments;
      });
    };

    $scope.delete_attachment = function(attachment) {
      if (confirm('Are you sure you want to delete this attachment?')) {
        attachment.deleting = true;
        OrderService.delete_attachment(attachment.id).success(function(data) {
          if (data.success) {
            attachment.deleting = false;
            load_data();
          }
        });
      }
    };

    $scope.init = function() {
      $scope.attachments = [];
      $scope.doc_types = _.where(window.document_types, {
        doc_type: window.document_type
      });
      $scope.doc_type = $scope.doc_types[0].id;
      set_uploaders();
      load_data();
    };

    $scope.init();
  }
}

OrderAttachments.$inject = ['$scope', '$rootScope', 'OrderService', 'FileUploader'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/order-attachments.ctrl.js